import React, { createContext, useState, useContext } from "react";
import OperatorsModal from "../components/modals/operators-modal";
import CompanyModal from "../components/modals/company-modal";
import PresetBudgetModal from "../components/modals/preset-budget-modal";
import BudgetNotesModal from "../components/modals/budget-notes-modal";
import CommercialsModal from "../components/modals/commercials-modal";
import GuildsModal from "../components/modals/guilds-modal";
import GmailCutMarkersModal from "../components/modals/gmail-cut-markers-modal";
import StatesModal from "../components/modals/states-modal";
import InvoiceCreateModal from "../components/modals/invoice-create-modal";
import RectificativaModal from "../components/modals/rectificativa-modal";
import PrefacturaToFacturaModal from "../components/modals/prefactura-to-factura-modal";
import JobTypeModal from "../components/modals/job-type-modal";
import LocalityModal from "../components/modals/locality-modal";
import ContactsModal from "../components/modals/contacts-modal";
import SendInvoiceModal from "../components/modals/SendInvoiceModal";
import VerifactuModal from "../components/modals/verifactu-modal";
import DarCobradoModal from "../components/modals/DarCobradoModal";
import QuitarCobradoModal from "../components/modals/QuitarCobradoModal";
import HonorariosPagadosModal from "../components/modals/HonorariosPagadosModal";
import LineDetailModal from "../components/modals/LineDetailModal";
import ListasModal from "../components/modals/ListasModal";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null);
  const [modalData, setModalData] = useState(null);

  const openModal = (modalName, data = null) => {
    setActiveModal(modalName);
    setModalData(data);
  };
  const closeModal = () => {
    setActiveModal(null);
    setModalData(null);
  };

  return (
    <ModalContext.Provider value={{ activeModal, openModal, closeModal, modalData }}>
      {children}
      {activeModal === "OperatorsModal" && (
        <OperatorsModal isOpen={true} onClose={closeModal} initialData={modalData} />
      )}
      {activeModal === "CompanyModal" && (
        <CompanyModal isOpen={true} onClose={closeModal} initialData={modalData} />
      )}
      {activeModal === "PresetBudgetModal" && (
        <PresetBudgetModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "BudgetNotesModal" && (
        <BudgetNotesModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "CommercialsModal" && (
        <CommercialsModal isOpen={true} onClose={closeModal} initialData={modalData} />
      )}
      {activeModal === "GuildsModal" && (
        <GuildsModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "GmailCutMarkersModal" && (
        <GmailCutMarkersModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "StatesModal" && (
        <StatesModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "InvoiceCreateModal" && (
        <InvoiceCreateModal 
          isOpen={true} 
          onClose={closeModal} 
          presupuestoData={modalData}
          onSuccess={modalData?.onSuccess}
        />
      )}
      {activeModal === "RectificativaModal" && (
        <RectificativaModal isOpen={true} onClose={closeModal} documentId={modalData?.documentId} onSuccess={modalData?.onSuccess} />
      )}
      {activeModal === "PrefacturaToFacturaModal" && (
        <PrefacturaToFacturaModal 
          isOpen={true} 
          onClose={closeModal} 
          prefacturaData={modalData?.prefacturaData} 
          prefacturaId={modalData?.prefacturaId}
          onSuccess={modalData?.onSuccess}
        />
      )}
      {activeModal === "JobTypeModal" && (
        <JobTypeModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "LocalityModal" && (
        <LocalityModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "ContactsModal" && (
        <ContactsModal isOpen={true} onClose={closeModal} initialData={modalData} />
      )}
      {activeModal === "SendInvoiceModal" && (
        <SendInvoiceModal 
          isOpen={true} 
          onClose={closeModal} 
          invoiceId={modalData?.invoiceId}
          expedienteId={modalData?.expedienteId}
          documentType={modalData?.documentType}
          onSuccess={modalData?.onSuccess}
        />
      )}
      {activeModal === "VerifactuModal" && (
        <VerifactuModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "DarCobradoModal" && (
        <DarCobradoModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "QuitarCobradoModal" && (
        <QuitarCobradoModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "HonorariosPagadosModal" && (
        <HonorariosPagadosModal isOpen={true} onClose={closeModal} />
      )}
      {activeModal === "LineDetailModal" && (
        <LineDetailModal isOpen={true} onClose={closeModal} lineId={modalData?.lineId} />
      )}
      {activeModal === "ListasModal" && (
        <ListasModal isOpen={true} onClose={closeModal} listType={modalData?.listType} />
      )}
      {/*activeModal === "AnotherModal" && (
        <AnotherModal isOpen={true} onClose={closeModal} />
      )*/}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);